import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { setOwner } from '../../../actions/spaces/SetOwnerAction';
import { CompositeSessionInfoSelectors } from '../../../selectors/SessionInfoSelectors';
import { AppState } from '../../../state/AppState';
import { ICollectionInfo } from '../../Collections/ICollectionInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { userCanManageAnyCollection } from './IEntityActionHelpers';

export const SetCollectionOwnerEntityAction: IEntityAction<ICollectionInfo, {}> = {
  name: EntityActionNames.SetOwner,
  translateName: Messages.changeOwner_action,
  isVisible: () => {
    return FeatureFlags.collectionsEnabled;
  },
  isClickable: (_availableActions: {}, targetItems: ICollectionInfo[], state: AppState) => {
    return !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state) && userCanManageAnyCollection(state, targetItems);
  },
  createReduxAction: (targetItems: ICollectionInfo[]) => setOwner(targetItems)
};
